export const prerender = true;
// 'never' keeps served URLs identical to the slash-less canonical URLs. It emits
// <path>.html, which the CloudFront url_rewrite function (cloud/terraform/main.tf)
// must map to — change both together.
export const trailingSlash = 'never';
